export async function getSwiperModules() {
    return import(
        /* webpackChunkName: "swiper/modules" */ 'swiper/modules'
    ).then(
        ({ Pagination, Autoplay, Navigation, Scrollbar, A11y, Keyboard }) => ({
            Pagination,
            Autoplay,
            Navigation,
            Scrollbar,
            A11y,
            Keyboard,
        }),
    );
}
